// extracted by mini-css-extract-plugin
export default {"page":"App_page__Syclb","flareAnimation":"App_flareAnimation__r+RaI"};